export default {
	state: () => {
		if (typeof document === 'undefined') return 'visible';
		return document.visibilityState ||
			document.webkitVisibilityState ||
			document.mozVisibilityState ||
			document.msVisibilityState;
	},

	get changeEvent() {
		return getChangeEvent();
	},

};

function getChangeEvent() {
	if (typeof document === 'undefined') return undefined;
	if (document.visibilityState) {
		return 'visibilitychange';
	} else if (document.webkitVisibilityState) {
		return 'webkitvisibilitychange';
	} else if (document.mozVisibilityState) {
		return 'mozvisibilitychange';
	} else if (document.msVisibilityState) {
		return 'msvisibilitychange';
	}
	return undefined;
}